$('[data-fancybox]').fancybox({
    touch: false
})
